export const LOGIN = "LOGIN";
export const REGISTER = "LOGIN";
export const CHECKAUTH = "CHECKAUTH";
export const SETSTORAGE = "SETSTORAGE";
export const GETSTORAGE = "GETSTORAGE";
export const SET_ACCOUNT = "SET_ACCOUNT";
export const SET_POSTS = "SET_POSTS";
export const SET_IMAGE = "SET_IMAGE";
export const LOGOUT = "LOGOUT";
export const GET_MY_POSTS = "GET_MY_POSTS";
